import { Dialog, DialogContent, DialogTitle, FormControlLabel, Grid2, Switch } from "@mui/material"
import MaterialBox from "../../../../components/MaterialBox"
import MaterialTypography from "../../../../components/MaterialTypography"
import MaterialInput from "../../../../components/MaterialInput"
import MaterialButton from "../../../../components/MaterialButton"
import { putData } from "../../../../services"
import { useSnackbar } from "../../../../context/popup"

const CategoryForm = ({showCategoryForm,setShowCategoryForm,listData,setListData}) => {
    const { showSnackbar } = useSnackbar();

    const handleUpdateCategory = async () => {
        const payload = { 
            categoryName: listData?.name,
            code: listData?.code,
            description: listData?.description,
            isActive: listData?.active 
        };
        try {
            const response = await putData(`/reference/general/key-value-category/${listData?.categoryId}`, payload);
            const responseMessage = response?.message;
            if(response?.success){
                //success pop up
                setShowCategoryForm(false);  
                showSnackbar(responseMessage,"success");
            }
            else{
                //error pop up
                showSnackbar(responseMessage,"error");
            }
        } catch (error) {
            console.error('Error posting data:', error);
            showSnackbar(error?.response?.data?.message || "Error Updating Data", "error");
        }
    };
    
  return (
    <Dialog open={showCategoryForm}>
        <DialogTitle>
            Edit {listData.category} Details
        </DialogTitle>
        <DialogContent>
            <Grid2 container spacing={2} alignItems="center">
                <Grid2 size={{lg:12, md:12, sm: 12, xs: 12 }}>
                    <MaterialBox>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        >
                            Category Name
                        </MaterialTypography>
                    </MaterialBox>                
                    <MaterialInput
                    name="category"
                    value={listData.category}
                    onChange={(e) =>
                        setListData((prev) => ({
                        ...prev,
                            desciption: e.target.value,
                        }))
                    }
                    success={listData.categoryStatus !== "" ? "success" : "unchecked"}
                    disabled
                    />
                </Grid2>
                <Grid2 size={{lg:12, md:12, sm: 12, xs: 12 }}>
                    <MaterialBox>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        >
                            Category Code
                        </MaterialTypography>
                    </MaterialBox>                
                    <MaterialInput
                    name="code"
                    value={listData.code}
                    onChange={(e) =>
                        setListData((prev) => ({
                        ...prev,
                            code: e.target.value,
                        }))
                    }
                    success={listData.codeStatus !== "" ? "success" : "unchecked"}
                    disabled
                    />
                </Grid2>
                <Grid2 size={{lg:12, md:12, sm: 12, xs: 12 }}>
                    <MaterialBox>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        >
                            Desciption
                        </MaterialTypography>
                    </MaterialBox>                
                    <MaterialInput
                    name="desciption"
                    value={listData.description}
                    onChange={(e) =>
                        setListData((prev) => ({
                        ...prev,
                            description: e.target.value,
                        }))
                    }
                    success={listData.descriptionStatus !== "" ? "success" : "unchecked"}
                    multiline
                    rows={3}
                    disabled
                    />
    
                </Grid2>

                <Grid2 size={{lg:12, md:12, sm: 12, xs: 12 }}>
                    <MaterialBox>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold">
                            Actve
                        </MaterialTypography>
                    </MaterialBox>
                    <FormControlLabel
                    control={
                        <Switch
                            checked={listData.active}
                            onChange={(e) =>
                                setListData((prev) => ({
                                ...prev,
                                active: e.target.checked,
                                }))
                            }                            
                            color="primary"
                        />
                    }
                    label={
                        <MaterialTypography variant="caption" fontWeight="bold">
                            {listData?.active ? "Yes" : "No"}
                        </MaterialTypography>
                    }
                    sx={{ marginLeft: 0 }}
                    />
                </Grid2>
            </Grid2>
        </DialogContent>
        {/* Dialog Actions */}
            <MaterialBox
            display="flex"
            justifyContent="space-between"
            alignItems="center">
                <MaterialButton
                variant="outlined"
                color="dark"
                size="small"
                sx={{ m: 2 }}
                onClick={() => setShowCategoryForm(false)}>
                    Cancel
                </MaterialButton>
                <MaterialButton
                variant="gradient"
                color="dark"
                sx={{ m: 2 }}
                onClick={handleUpdateCategory}
                size="small">
                    Update
                </MaterialButton>
            </MaterialBox>
    </Dialog>
  )
}

export default CategoryForm